import React from 'react';
import Image from 'react-bootstrap/Image';
import Card from 'react-bootstrap/Card';

import nexoBannerEarn from '../../assets/images/banners/nexo-earn.2.png';
import nexoBannerBorrow from '../../assets/images/banners/nexo-borrow.2.png';

const bannerVariations = [
  {
    banner: nexoBannerEarn,
    href: "https://api.xrpscan.com/api/v1/campaign/nexobannerearn1",
  },
  {
    banner: nexoBannerBorrow,
    href: "https://api.xrpscan.com/api/v1/campaign/nexobannerborrow1",
  },
];
const nexoBanner = bannerVariations[ Math.floor(Math.random() * bannerVariations.length) || 0 ];

const BannerAd = () => {
  return (
    <div>
      <Card className="shadow-sm">
        <a
          href={nexoBanner.href}
          rel="noopener noreferrer nofollow"
          target="_blank"
        >
          <Image src={nexoBanner.banner} fluid height={99.8} width={1400}/>
        </a>
      </Card>
    </div>
  );
}

export default BannerAd;